import { GraphQlRequestError } from '~/graphql/graphqlClient';
import mutationNewsletterUnsubscribe from '~/graphql/player/mutationNewsletterUnsubscribe';

type SocialState = Record<string, unknown> & {
  signed_up_newsletter?: boolean | null;
  newsletter_email?: string | null;
};

type NewsletterUnsubscribeEvent = 'NEWSLETTER_UNSUBSCRIBE_ERROR' | 'NEWSLETTER_UNSUBSCRIBE_SUCCESS';

export default async function newsletterUnsubscribe(
  {
    playerId,
    setSocial,
    emit,
  }: {
    playerId: string | null | false;
    setSocial: (updater: (prev: SocialState) => SocialState) => void;
    emit: (event: NewsletterUnsubscribeEvent, payload?: string) => void;
  },
  action: { email?: string | null }
) {
  if (!playerId) {
    emit('NEWSLETTER_UNSUBSCRIBE_ERROR', 'Not logged in.');
    return;
  }

  try {
    const result = await mutationNewsletterUnsubscribe({
      playerId: String(playerId),
      ...(action.email ? { email: action.email } : {}),
    });

    if (!result.ok) {
      emit('NEWSLETTER_UNSUBSCRIBE_ERROR', result.detail || 'An error occurred');
      return;
    }

    setSocial((prev) => ({
      ...(prev || {}),
      newsletter_email: null,
    }));
    emit('NEWSLETTER_UNSUBSCRIBE_SUCCESS');
  } catch (err) {
    // If this was a GraphQL transport/execute error, prefer its message.
    const detail = err instanceof GraphQlRequestError ? err.errors?.[0]?.message : undefined;
    emit('NEWSLETTER_UNSUBSCRIBE_ERROR', detail || 'Server error.');
  }
}
